<template>
  <div class="form-group">
    <label :for="`translate-item-${generateRandomString()}`">{{ translationKey }}</label>
    <textarea @keyup="showValue" :value="setTranslationValue" :id="`translate-item-${generateRandomString()}`" class="form-control"  cols="30" rows="2">

    </textarea>
  </div>
</template>

<script>
import {generateRandomString} from "@/store/Modules/Site";

export default {
  name: "TranslateInput",
  props: {
    translationObject: {},
    translationKey: {},
  },
  computed: {
    setTranslationValue() {
      let translationKey = this.translationKey
      let translationObject = this.translationObject
      translationKey = translationKey.split('.')

      translationKey.forEach(key => {
        translationObject = translationObject[key]
      })

      return translationObject
    }
  },
  methods: {
    generateRandomString,
    showValue(event) {
      const value = event.target.value;
      this.$store.dispatch('Site/setTranslationItem', {value: value, translationItemPath: this.translationKey})
    }
  }
}
</script>

<style scoped>

</style>